module.exports = __webpack_public_path__ + "static/media/تأجير سيارة مع سائق عربي في سويسرا.328fec4e.jpg";